import PeriodRequest from '@/app/models/sharingPMO';
import { useTeacherPaymentFileMutation } from '@/app/services/teacherPaymentApi';
import PageTitle from '@/components/pageTitle';
import SearchFile from '@/components/SearchFieldFile';
import { Button, Stack } from '@mui/material';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import PeriodSelect from '../periodSelect';

interface NewEditTeacherPaymentProps {
  periodRequest: PeriodRequest | null;
  setDrawerOpen: (open: boolean) => void;
}

export default function NewEditTeacherPaymentScreen(props: NewEditTeacherPaymentProps) {
  const { t } = useTranslation(['teacherPayment', 'common']);
  const [saveDisabled, setSaveDisabled] = useState(true);

  const { periodRequest, setDrawerOpen } = props;

  const [sharingFile, setSharingFile] = useState(null as unknown as File);

  const [selectedPeriodDate, setSelectedPeriodDate] = useState<dayjs.Dayjs | null>(dayjs());

  useEffect(() => {
    const enabled = selectedPeriodDate && sharingFile;
    setSaveDisabled(!enabled);
  }, [selectedPeriodDate, sharingFile]);

  const [processRequest] = useTeacherPaymentFileMutation();

  const handleProcess = async () => {
    const formData = new FormData();
    formData.append('file', sharingFile || '');
    const newProcessRequest = {
      body: formData,
      periodDate: selectedPeriodDate?.format('YYYY-MM-DD') || '',
    };
    toast.success(
      t('common:file.being.sent', {
        position: toast.POSITION.TOP_RIGHT,
      }),
    );
    const response = await processRequest(newProcessRequest);
    if ('data' in response) {
      toast.success(
        t('common:file.sent.successfully', {
          position: toast.POSITION.TOP_RIGHT,
        }),
      );
    }
  };

  return (
    <div
      style={{
        width: 480,
        backgroundColor: '#FAFAFA',
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        padding: '24px',
      }}
    >
      <PageTitle title={t('import.teacher.payment.file')} />
      <div style={{ marginBottom: '24px' }} />
      <PeriodSelect
        selectedPeriodDate={selectedPeriodDate}
        setSelectedPeriodDate={setSelectedPeriodDate}
      />
      <div style={{ marginBottom: '24px' }} />

      <SearchFile sharingFile={sharingFile} setSharingFile={setSharingFile} />

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          marginBottom: '8px',
          marginTop: 'auto',
        }}
      >
        <Stack
          direction="row"
          justifyContent="flex-end"
          alignItems="baseline"
          margin={3}
          spacing={2}
        >
          <Button
            variant="secondary"
            onClick={() => {
              setDrawerOpen(false);
            }}
          >
            {t('common:cancel')}
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              handleProcess();
              setDrawerOpen(false);
            }}
            disabled={saveDisabled}
          >
            {t('common:import')}
          </Button>
        </Stack>
      </div>
    </div>
  );
}
